// shared.service.ts
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  
  private openManageNotificationSubject = new Subject<void>();
  
  openManageNotification$ = this.openManageNotificationSubject.asObservable();

  triggerOpenManageNotification() {
    this.openManageNotificationSubject.next();
  }

}